import React from "react";
import Modal from "react-bootstrap/Modal";
import { Descriptions, Tag, Divider, Empty } from "antd";
import moment from "moment";
import capitalize from "../../../../../../capitalize";

const statusTagColor = (status) => {
  switch ((status || "").toLowerCase()) {
    case "completed":
      return "green";
    case "processing":
      return "blue";
    case "cancelled":
    case "rejected":
      return "red";
    default:
      return "gold";
  }
};

const EvacDetailsModal = ({ showDetails, handleCloseDetails, record }) => {
  const groups = Array.isArray(record?.evacuation_groups)
    ? record.evacuation_groups
    : null;

  const totalKg =
    record?.total_evacuated_kg ?? record?.total_requested_kg ?? null;

  return (
    <Modal
      show={showDetails}
      onHide={handleCloseDetails}
      size="lg"
      centered
      dialogClassName="evacDetailsModal"
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title style={{ fontSize: "17px", fontWeight: 700 }}>
            Evacuation Request
          </Modal.Title>
          {record?.code && (
            <p className="mb-0" style={{ fontSize: "12px", color: "#898989" }}>
              Code: {record.code}
            </p>
          )}
        </div>
      </Modal.Header>
      <Modal.Body>
        {!record ? (
          <Empty description="No details to show" />
        ) : (
          <div>
            <div className="evacDetails__summary">
              <div>
                <span className="evacPendingCard__label">Total Weight</span>
                <div className="evacDetails__summaryWeight">
                  {totalKg !== null ? totalKg : "—"}
                  <span>kg</span>
                </div>
              </div>
              <Tag color={statusTagColor(record?.status)} className="evacStatusTag">
                {record?.status ? capitalize(record.status) : "—"}
              </Tag>
            </div>

            <Descriptions column={2} size="small" bordered>
              <Descriptions.Item label="Date">
                {record?.created_at
                  ? moment(record.created_at).format("DD MMM YYYY")
                  : "—"}
              </Descriptions.Item>
              <Descriptions.Item label="Time">
                {record?.created_at
                  ? moment(record.created_at).format("HH:mm")
                  : "—"}
              </Descriptions.Item>
              <Descriptions.Item label="Driver Name">
                {record?.driver_name || "—"}
              </Descriptions.Item>
              <Descriptions.Item label="Driver Phone">
                {record?.driver_phone || "—"}
              </Descriptions.Item>
              <Descriptions.Item label="Vehicle No" span={2}>
                {record?.vehicle_plate_no || "—"}
              </Descriptions.Item>
            </Descriptions>

            <Divider orientation="left" plain style={{ fontSize: "13px" }}>
              Weight Breakdown
            </Divider>

            {groups && groups.length > 0 ? (
              <div className="evacGroupChips">
                {groups.map((g) => (
                  <span className="evacGroupChip" key={g.label}>
                    {g.name || g.label}:{" "}
                    <b>
                      {g.evacuated_kg !== undefined && g.evacuated_kg !== null
                        ? `${g.evacuated_kg}kg`
                        : `${Number(g.requested_kg) || 0}kg`}
                    </b>
                    {g.evacuated_kg !== undefined && g.evacuated_kg !== null && (
                      <span style={{ color: "#898989", fontWeight: 400 }}>
                        {` (requested ${Number(g.requested_kg) || 0}kg)`}
                      </span>
                    )}
                  </span>
                ))}
              </div>
            ) : (
              <Descriptions column={2} size="small" bordered>
                <Descriptions.Item label="Nylon">
                  {record?.nylon_kg ? `${record.nylon_kg}kg` : "—"}
                </Descriptions.Item>
                <Descriptions.Item label="PET Plastics">
                  {record?.pet_plastic_kg ? `${record.pet_plastic_kg}kg` : "—"}
                </Descriptions.Item>
              </Descriptions>
            )}
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
};

export default EvacDetailsModal;
